
import { Component, Mixins } from "vue-property-decorator";
import { default as ForegroundDrawableObjectMixin } from "./ForegroundDrawableObjectMixin.vue";
import { default as LineDrawableMixin } from "./LineDrawableMixin.vue";
import { default as DraggableMixin } from "./DraggableMixin.vue";

@Component
export default class DraggableLineDrawableObjectMixin extends Mixins(
  ForegroundDrawableObjectMixin,
  LineDrawableMixin,
  DraggableMixin
) {
}
